/* eslint-disable react/prop-types */
function FacebookIcon({ className = "", fill = "#000000", size = "24" }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 29.34 29.34" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path fill={fill} d="M15.93,22.07v-7.45h2.5l.37-2.9h-2.87v-1.85c0-.84,.23-1.41,1.44-1.41h1.54v-2.6c-.27-.04-1.18-.11-2.24-.11-2.22,0-3.73,1.35-3.73,3.84v2.14h-2.51v2.9h2.51v7.45h3Z"/>
        <circle fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth="2px" cx="14.67" cy="14.67" r="13.67"/>
      </g>
    </svg>
  )
}

export default FacebookIcon